'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dKeyword from "./mealorama.-Keyword.js";
var $p;
/** @constructor */
function $c_Lmealorama_Keyword$() {
}
export { $c_Lmealorama_Keyword$ as $c_Lmealorama_Keyword$ };
$p = $c_Lmealorama_Keyword$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Keyword$;
/** @constructor */
function $h_Lmealorama_Keyword$() {
}
export { $h_Lmealorama_Keyword$ as $h_Lmealorama_Keyword$ };
$h_Lmealorama_Keyword$.prototype = $p;
$p.aSk = (function(x$0) {
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  var $x_2 = x$0.g(1);
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(2));
  return new $j_mealorama$002e$002dKeyword.$c_Lmealorama_Keyword($x_3.l, $x_3.h, $x_2, $x_1.l, $x_1.h);
});
var $d_Lmealorama_Keyword$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Keyword$, "mealorama.Keyword$", ({
  FV: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_Keyword$ as $d_Lmealorama_Keyword$ };
var $n_Lmealorama_Keyword$;
function $m_Lmealorama_Keyword$() {
  if ((!$n_Lmealorama_Keyword$)) {
    $n_Lmealorama_Keyword$ = new $c_Lmealorama_Keyword$();
  }
  return $n_Lmealorama_Keyword$;
}
export { $m_Lmealorama_Keyword$ as $m_Lmealorama_Keyword$ };
//# sourceMappingURL=mealorama.-Keyword$.js.map
